
<template>
  <footer class="animated-bottom">
    <div class="content-center">
      <router-link to="/" class="logo-dark" />
      <p>
        Ajudando milhares de streamers <br />
        a receberem donates pela menor taxa
      </p>

      <div class="social-content">
        <!-- <a href="#">
          <i class="bx bxl-discord-alt"></i>
        </a> -->
        <a href="https://twitter.com/pixggbr?s=21&t=aB68tbKW0AtFq1r1CvUCNg" target="_blank">
          <i class="bx bxl-twitter"></i>
        </a>
        <a href="https://www.instagram.com/pixggbr/?igshid=MzRlODBiNWFlZA%3D%3D" target="_blank">
          <i class="bx bxl-instagram-alt"></i>
        </a>
      </div>

      <p style="margin-top: 1rem" class="content-link">
        <router-link class="underline" to="termos-de-uso"
          >Termos de uso</router-link
        >
        •
        <router-link class="underline" to="politica-de-privacidade"
          >Política de privacidade</router-link
        >
      </p>

      <p class="content-link">
        Email: contato@pixgg.com • CNPJ: 50.741.748/0001-13
      </p>
    </div>
  </footer>
</template>

<style scoped>
footer {
  background-color: var(--purple-2);
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  gap: 10px;
  padding: 75px 1rem 35px;
  user-select: none;
}

.dark-mode footer {
  background-color: #0e1135;
}

footer .content-center {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
}
footer .content-center p {
  text-align: center;
  margin-top: 1rem;
  font-size: 20px;
  line-height: 30px;
}

.dark-mode footer .content-center p {
  color: var(--black);
}

footer .content-center .social-content {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin-top: 1rem;
}

footer .content-center .social-content .bx {
  font-size: 22px;
  text-align: center;
  transition: 0.4s;
}

footer .content-center .social-content .bx:hover {
  opacity: 1;
}

.dark-mode .content-center .social-content .bx {
  color: var(--black);
  opacity: 0.7;
  font-size: 30px;
}

.dark-mode footer p.content-link,
.content-link a {
  color: #e0e0e0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
  justify-content: center;
  font-size: 12px;
  line-height: normal;
  margin: 0rem;
}
.bx.bxs-circle {
  font-size: 7px;
  color: #e0e0e0;
}

a.underline::after {
  content: "";
  background-color: #e0e0e0;
}
</style>





